<template>
  <b-container fluid>
    <backlink />
    <h1>Administration de l'équipe</h1>
    <div class="ibox">
      <div class="ibox-content divided">
        <b-row>
          <b-col>
            <div class="the-team-form">
              <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options" @submit:create:success="postFile" @submit:update:success="postFile"></AdminForm>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "TheTeamForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        members: [{ lastname: null, firstname: null, function: null, email: null, photo_id: null, photo: null }],
      },
      isBusy: false
    };
  },
  computed: {
    options: function () {
    },
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            members: item.members.sort((a, b) => a.order_number - b.order_number).map(i => ({
              ...i,
              stored_files: i.stored_files.length ? i.stored_files[0].file : null
            }))
          };
          this.isBusy = false;
          // On sauvegarde les données initiales, donc avant modification dans le form, pour ensuite
          // les utiliser dans la gestion des fichiers joints
          this.initialForm = _.cloneDeep(this.form);
        });
    }
  },
  methods: {
    postFile(response) {

      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: response.data.object.id,
          wait: true
        })
        .then(() => {
          let theteam = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](response.data.object.id)
          );

          if(theteam.members.length > 0){
            theteam.members.forEach((member, index) => {

              // Si il ya une photo
              if (this.form.members[index].stored_files && typeof this.form.members[index].stored_files == "object" && this.form.members[index].stored_files.type) {
                // Si il ne s'agit pas d'un fichier déjà présent
                let item = {
                  team_member_id: theteam.members[index].id,
                  type_slug: "teammember-picture",
                  format: this.form.members[index].stored_files.type,
                  file: this.form.members[index].stored_files,
                };

                this.$store.dispatch("stored_file/addItem", item).then((response) => {
                  this.$store.dispatch(config.storeNamespace + "/getItem", {
                    id: this.form.id,
                  });
                });
              }
            });
          }
          this.isBusy = false;
        });
    },
  },
};
</script>


<style lang="scss">
@import "~@/assets/scss/_variables.scss";

.the-team-form{
  .group_repeater {
    .field_group{ flex-wrap: wrap;
      .custom-file{ width: calc(100% - 30px); margin-right: 0; }
      .file-preview{ width: calc(100% - 50px); margin-right: 0 !important; }
      #firstname{ margin-right: 0; }
      #phone_number{ margin-right: 0; }
      input[type=text]:not(.custom-file){ width: calc(50% - 20px); }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TheTeam/TheTeamForm.vue